import { http } from "../http-common";
import { PageableResponse } from "../types/pagination";

export interface IAccountLite {
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface INonconformityReason {
  id: number;
  abbreviation: string;
  description: string;
  accountId?: number | null;
  account?: IAccountLite | null;
  isGeneral: boolean;
  used?: boolean;
  editable?: boolean;
  attributeId?: number | null;
  attributeName?: string | null;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface INonconformityReasonPayload {
  abbreviation: string;
  description: string;
  accountId?: number | null;
  isGeneral: boolean;
  attributeId?: number | null;
}

const list = (params?: any) => {
  const queryParams = {
    ...(params || {}),
    page: params?.page ?? 0,
    size: params?.size ?? 20,
  };
  return http.get<PageableResponse<INonconformityReason>>("/nonconformity-reasons", {
    params: queryParams,
  });
};

const listAll = (params?: any) => {
  return http.get<INonconformityReason[]>("/nonconformity-reasons/list", {
    params,
  });
};

const create = (data: INonconformityReasonPayload) => {
  return http.post<INonconformityReason>("/nonconformity-reasons", data);
};

const update = (id: number, data: INonconformityReasonPayload) => {
  return http.put<INonconformityReason>(`/nonconformity-reasons/${id}`, data);
};

const remove = (id: number) => {
  return http.delete(`/nonconformity-reasons/${id}`);
};

const NonconformityReasonService = {
  list,
  listAll,
  create,
  update,
  remove,
};

export default NonconformityReasonService;
